import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { Dialog, DialogContent } from './ui/dialog';
import { christmasVideos } from '../christmas';

export const ChristmasVideos = ({ lang }) => {
  const [video, setVideo] = useState(null);
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-6">
        {christmasVideos.map((v, i) => (
          <Reveal key={v.id} delay={i * 90}>
            <button data-testid={`xmas-video-${v.id}`} onClick={() => setVideo(v.id)}
              className="group card-lux relative w-full text-left overflow-hidden">
              <div className="relative aspect-video overflow-hidden">
                <img src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`} alt={v.title} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 rounded-full bg-[#e6b83f]/90 flex items-center justify-center text-[#14120d] group-hover:scale-110 transition-transform">
                    <Play size={26} fill="currentColor" />
                  </span>
                </span>
                <span className="absolute top-4 left-4 bg-[#b3262e]/90 text-[#f7eccf] font-sans-el text-[11px] tracking-[0.2em] uppercase px-3 py-1 rounded-sm">
                  {v.tag[lang]}
                </span>
                <h3 className="absolute bottom-4 left-5 font-deco text-2xl text-[#f7f1e3]">{v.title}</h3>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
      <Dialog open={!!video} onOpenChange={(o) => !o && setVideo(null)}>
        <DialogContent className="max-w-4xl bg-transparent border-0 p-0 shadow-none">
          {video && (
            <div className="aspect-video w-full">
              <iframe data-testid="xmas-video-player" className="w-full h-full rounded-sm"
                src={`https://www.youtube.com/embed/${video}?autoplay=1`} title="LAJO Navidad"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
